import { autocomplete } from '@algolia/autocomplete-js'
import React, { createElement, Fragment, useEffect, useRef } from 'react'
import { render } from 'react-dom'

const Autocomplete = (props) => {
    const containerRef = useRef(null)
    const autocompleteRef = useRef(null)

    useEffect(() => {
        if (!containerRef.current) {
            return undefined
        }

        const search = autocomplete({
            container: containerRef.current,
            renderer: { createElement, Fragment },
            render({ children }, root) {
                render(children, root)
            },
            ...props,
        })

        autocompleteRef.current = search

        const handleDocumentClick = (event) => {
            const target = event.target
            const panel = document.querySelector('.aa-Panel')

            if (!containerRef.current.contains(target) && !(panel && panel.contains(target))) {
                autocompleteRef.current?.setIsOpen(false)
            }
        }

        document.addEventListener('click', handleDocumentClick)

        return () => {
            document.removeEventListener('click', handleDocumentClick)
            search.destroy()
        }
    }, [])

    return <div ref={containerRef} />
}

export default Autocomplete
